import maplibregl from 'maplibre-gl';
import type { GpsPosition } from '../sensors/gps';

// src/map/trainIcon.ts
export function createTrainEl(svgPath = "/marker-train-fret-up.svg") {
  const el = document.createElement("img");
  el.src = svgPath;
  el.alt = "Train";
  el.style.width = "40px";   // ajuste selon le zoom
  el.style.height = "103px"; // ~48 * (180/84)
  el.style.filter = "drop-shadow(0 1px 2px rgba(0,0,0,.6)) drop-shadow(0 8px 16px rgba(0,0,0,.45))";
  el.style.transformOrigin = "50% 50%";
  return el;
}

export function createTrainMarker(svgPath = "/marker-train-fret-up.svg") {
  const el = createTrainEl(svgPath);
  return el;
}

export function updateMarkerPosition(marker: maplibregl.Marker, position: GpsPosition, forceShow: boolean = true) {
  marker.setLngLat([position.lon, position.lat]);
  
  const element = marker.getElement();
  if (element) {
    if (forceShow) {
      element.style.display = 'block';
      element.style.opacity = '1';
      element.style.visibility = 'visible';
    } else {
      // Cacher complètement en simulation
      element.style.display = 'none';
      element.style.opacity = '0';
      element.style.visibility = 'hidden';
      element.style.transform = 'scale(0)'; // Suppression totale
    }
  }
}
